import { render, staticRenderFns } from "./ValidateTextComponent.vue?vue&type=template&id=6c305ccb&scoped=true&"
import script from "./ValidateTextComponent.vue?vue&type=script&lang=js&"
export * from "./ValidateTextComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c305ccb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
